export function getEmailThreadProfileNextUpdatedData(prevData, data) {
  // #INFO Add necessary properties after updating profile
  return { ...prevData, starred: data.starred }
}
